import React, { ReactElement } from 'react';
import TableRow from '../table-row/table-row.component';
import FormatService from '../../services/format-service';
import useStylesTableRowSummary from './table-row-summary.styles';

const TableRowSummary: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isBordered,
    withOffset,
    withDarkBorders,
    withNoHighlight,
    children,
  } = props;

  const { classes } = useStylesTableRowSummary();

  const borderedClassName: string | undefined = isBordered ? classes.tableRowSummaryBordered : undefined;
  const noHighlightClassName: string | undefined = withNoHighlight ? classes.tableRowSummaryNoHighlight : undefined;
  const offsetClassName: string | undefined = withOffset ? classes.tableRowSummaryOffset : undefined;
  const darkBordersClassName: string | undefined = withDarkBorders ? classes.tableRowSummaryDarkBorders : undefined;

  return (
    <TableRow
      className={FormatService.formatClassNames(
        classes.tableRowSummary, borderedClassName, noHighlightClassName, offsetClassName, darkBordersClassName,
      )}
    >
      {children}
    </TableRow>
  );
});

export default TableRowSummary;
